import styled from '@emotion/styled';

export const OperationsRequestsContainer = styled.div`
  width: 100%;
  height: 100%;
`;
